import { render, staticRenderFns } from "./orderItemNCRDialog.vue?vue&type=template&id=6b8d0a49&"
import script from "./orderItemNCRDialog.vue?vue&type=script&lang=js&"
export * from "./orderItemNCRDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports